import React, { useState, useEffect } from 'react';
import { FileText, Trash2 } from 'lucide-react';
import api from '../services/api';

export default function Midias() {
  const [clientes, setClientes] = useState([]);
  const [funcionarios, setFuncionarios] = useState([]);
  const [clienteId, setClienteId] = useState('');
  const [midias, setMidias] = useState([]);
  const [file, setFile] = useState(null);
  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');
  const [funcionarioId, setFuncionarioId] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    api.get('/api/clientes').then(r => setClientes(r.data)).catch(() => {});
    api.get('/api/funcionarios').then(r => setFuncionarios(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!clienteId) { setMidias([]); return; }
    api.get('/api/midias/' + clienteId).then(r => setMidias(r.data)).catch(() => setMidias([]));
  }, [clienteId]);

  const loadMidias = () => {
    if (!clienteId) return;
    api.get('/api/midias/' + clienteId).then(r => setMidias(r.data)).catch(() => {});
  };

  const upload = async () => {
    if (!clienteId) { setMsg('Selecione um cliente.'); return; }
    if (!file) { setMsg('Escolha um arquivo.'); return; }
    setEnviando(true); setMsg('');
    try {
      const fd = new FormData();
      fd.append('arquivo', file);
      if (nome) fd.append('nome', nome);
      if (descricao) fd.append('descricao', descricao);
      if (funcionarioId) fd.append('funcionario_id', funcionarioId);
      await api.post('/api/midias/' + clienteId + '/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setFile(null); setNome(''); setDescricao(''); setFuncionarioId('');
      const fi = document.getElementById('midia-file'); if (fi) fi.value = '';
      setMsg('Enviado!');
      loadMidias();
    } catch (e) { setMsg('Erro: ' + ((e.response && e.response.data && e.response.data.error) || e.message)); }
    setEnviando(false);
  };

  const remover = async (id) => {
    if (!window.confirm('Remover esta midia?')) return;
    try { await api.delete('/api/midias/' + id); loadMidias(); } catch (e) { alert('Erro: ' + e.message); }
  };

  const funcsDoCliente = funcionarios.filter(f => f.cliente_id === clienteId);

  return (
    <div>
      <h1 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 24, marginBottom: 8 }}>Midias</h1>
      <p style={{ color: 'var(--text-secondary)', marginBottom: 24, fontSize: 14 }}>Suba catalogos, fotos e documentos (PDF, JPG, PNG, WEBP - ate 5MB). A IA envia sozinha quando o cliente pedir.</p>

      <div className="form-group" style={{ maxWidth: 420 }}>
        <label>Cliente</label>
        <select value={clienteId} onChange={e => setClienteId(e.target.value)}>
          <option value="">Selecione...</option>
          {clientes.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
        </select>
      </div>

      {clienteId && (
        <div>
          <div style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 12, padding: 20, maxWidth: 560, marginBottom: 28 }}>
            <h3 style={{ fontSize: 15, marginBottom: 16 }}>Nova midia</h3>
            <div className="form-group"><label>Arquivo</label><input id="midia-file" type="file" accept=".pdf,.jpg,.jpeg,.png,.webp" onChange={e => setFile(e.target.files[0])} /></div>
            <div className="form-group"><label>Nome (opcional)</label><input value={nome} onChange={e => setNome(e.target.value)} placeholder="Ex: Catalogo Miami" /></div>
            <div className="form-group"><label>Descricao (ajuda a IA a saber quando enviar)</label><input value={descricao} onChange={e => setDescricao(e.target.value)} placeholder="Ex: Catalogo completo de precos Premium e Original" /></div>
            <div className="form-group"><label>Disponivel para</label>
              <select value={funcionarioId} onChange={e => setFuncionarioId(e.target.value)}>
                <option value="">Todos os agentes do cliente</option>
                {funcsDoCliente.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
              </select>
            </div>
            <button onClick={upload} disabled={enviando} style={{ background: 'var(--purple-500)', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', cursor: 'pointer', fontSize: 14, marginTop: 4 }}>{enviando ? 'Enviando...' : 'Subir midia'}</button>
            {msg && <span style={{ marginLeft: 14, fontSize: 13, color: 'var(--text-secondary)' }}>{msg}</span>}
          </div>

          <h3 style={{ fontSize: 15, marginBottom: 12 }}>Midias deste cliente</h3>
          {midias.length === 0 ? <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>Nenhuma midia ainda.</p> : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 700 }}>
              {midias.map(m => (
                <div key={m.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 10, padding: '12px 16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <FileText size={18} style={{ color: 'var(--purple-400)' }} />
                    <div>
                      <div style={{ fontSize: 14 }}>{m.nome}</div>
                      <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{m.tipo}{m.funcionario_nome ? ' - ' + m.funcionario_nome : ' - geral'}{m.descricao ? ' - ' + m.descricao : ''}</div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                    <a href={'/midias/' + m.cliente_id + '/' + m.arquivo} target="_blank" rel="noreferrer" style={{ color: 'var(--text-secondary)', fontSize: 13 }}>Ver</a>
                    <button onClick={() => remover(m.id)} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer' }}><Trash2 size={16} /></button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
